<template>
  <v-snackbar
    :timeout="3000"
    :value="crudMessage.show"
    :color="crudMessage.color"
    top
    text
    @input="(e) => !e ? hideCrudMessage() : null">
    <v-icon :color="crudMessage.color" class="mr-2" v-text="crudIcon(crudMessage.type)" />
    <span v-html="crudMessage.text" />
  </v-snackbar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import {
  mdiAxe,
  mdiPound,
  mdiCompass,
  mdiCrown,
  mdiAccount
} from '@mdi/js';

export default {
  name: 'crudMessageSnackbar',
  data() {
    return {
      mdiAxe,
      mdiPound,
      mdiCompass,
      mdiCrown,
      mdiAccount
    };
  },
  computed: {
    ...mapGetters([
      'crudMessage'
    ])
  },
  methods: {
    ...mapMutations([
      'hideCrudMessage'
    ]),
    crudIcon(type) {
      switch (type) {
        case 'tool':
          return mdiAxe;
        case 'tag':
          return mdiPound;
        case 'objective':
          return mdiCompass;
        case 'play':
          return mdiCrown;
        case 'user':
          return mdiAccount;
        default:
          return null;
      }
    }
  }
};
</script>
